import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import FlagIcon from '@mui/icons-material/Flag';
import SyncAltOutlinedIcon from '@mui/icons-material/SyncAltOutlined';
import DoneOutlinedIcon from '@mui/icons-material/DoneOutlined';
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
import FunctionsOutlinedIcon from '@mui/icons-material/FunctionsOutlined';
import LanOutlinedIcon from '@mui/icons-material/LanOutlined';
import HubOutlinedIcon from '@mui/icons-material/HubOutlined';
import QuestionAnswerOutlinedIcon from '@mui/icons-material/QuestionAnswerOutlined';
import QueryBuilderOutlinedIcon from '@material-ui/icons/QueryBuilderOutlined';

export const IconsConexaBot: Record<string, JSX.Element> = {
    message: <ChatBubbleOutlineOutlinedIcon />,
    question: <HelpOutlineOutlinedIcon />,
    start: <FlagIcon />,
    transfer: <SyncAltOutlinedIcon />,
    finish: <DoneOutlinedIcon />,
    await: <TimerOutlinedIcon />,
    variable: <FunctionsOutlinedIcon />,
    simpleCondition: <LanOutlinedIcon />,
    compoundCondition: <HubOutlinedIcon />,
    quickReply: <QuestionAnswerOutlinedIcon />,
    openingHour: <QueryBuilderOutlinedIcon />
};